import { render, staticRenderFns } from "./CounterComponent.vue?vue&type=template&id=76bcbac8"
import script from "./CounterComponent.vue?vue&type=script&lang=js"
export * from "./CounterComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports